import { useState } from "react";

import { clsxMerge } from "shared/lib/helpers";

import { getLogoPath } from "./utils";
import { LogoPropsI } from "./interfaces";

export const Logo = ({
  variation,
  width,
  className,
  href,
  fallbackRoute,
  imageClassName,
}: LogoPropsI) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <a href={href || fallbackRoute} className={className}>
      <img
        className={clsxMerge(
          "max-w-full opacity-0 transition-opacity",
          isLoaded && "opacity-100",
          imageClassName
        )}
        src={getLogoPath(variation)}
        alt="Glencoco Logo"
        width={width || "89px"}
        onLoad={() => setIsLoaded(true)}
      />
    </a>
  );
};
